export const LIST_ITEM_ONHOVER_COLOR = {
  "&:hover": {
    backgroundColor: "rgba(142, 216, 248, 0.40)"
  }
};
